import {
    GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG,
    RESET_GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG,
    API_REQUEST,
} from "../../actionTypes/actionsTypes";
import { AppAction, LocalAction } from "../../types";

export const generateDocumentViewerLinkAddLog = (payload: Record<string, string | string[] | number | boolean | null>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: "/income/generate-document-viewer-link-add-log",
        next: GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG,
        method: 'POST',
        authorization: true,
        data: { payload: payload }
    }
});

export const resetGenerateDocumentViewerLinkAddLog = (): LocalAction => ({
    type: RESET_GENERATE_VIEW_DOCUMENT_LINK_ADD_LOG
});

